import { ISgSdkHandler, TriggerAction } from "./types";

declare const azAdWrapper: any;
declare const h5ads: any;
declare const sdkHandler: ISgSdkHandler;

export function showInterstitial() {
  return new Promise<void>(resolve => {
    sdkHandler.trigger(TriggerAction.BEFORE_PLAY_BUTTON_DISPLAY, {
      callback() {
        sdkHandler.isAdPLaying = true;
        let loader: HTMLElement = document.getElementById('loader') as any;
        loader.style.display = 'block';
        azAdWrapper.once(h5ads.AdEvents.CONTENT_PAUSED, () => {
          console.log('paused');
          loader.style.display = 'none';
        });

        azAdWrapper.once(h5ads.AdEvents.CONTENT_RESUMED, () => {
          loader.style.display = 'none';
          console.log('resumed');
          window.focus();
          azAdWrapper.removeAllListeners(h5ads.AdEvents.CONTENT_PAUSED);
          azAdWrapper.removeAllListeners(h5ads.AdEvents.CONTENT_RESUMED);
          sdkHandler.isAdPLaying = false;
          resolve();
        });

        azAdWrapper.showAd(h5ads.AdType.interstitial);
      },
    });
  });
}
